import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import "../css/MorganIntro.css";
import ReactPlayer from 'react-player/lazy';

export default function MorganIntro({links}) {
  const imgCDNURL = process.env.REACT_APP_POSTNU_CDN_URL;
  return (
    <Container fluid>
      <Row className=" justify-content-center logomovetext">
        <Col xs={12} lg={9} className="morgnindex">

          <Row>
            <Col
              xs={12}
              sm={7}
              md={5}
              lg={3}
              className=" morganimagealign d-block"
            >
              <div className="morgan-new">
              <a
                target="_blank"
                href={links.current.mobileAppURL}
                rel="noopender"
              >
                <img src="https://d2w24n4g34usfg.cloudfront.net/HelloMorgan/images/morgan-logo.webp" width="150px" className="morgan-desk"></img>
                <img src="https://stagingresources.swmc.com/angel-ai/angelai-btn.png" />
              </a>
              </div>

            </Col>

            <Col  
            md={12} 
            lg={4} 
            xl={4} 
            xs={12}
              className= "posteventvideo"
              >
              <div id="main-player" className="player-wrapper">
                <ReactPlayer
                  className="react-player"
                  url="https://www.youtube.com/watch?v=oJk5Ug03cyI"
                  width="115%" height="130%"
                  light={`${process.env.REACT_APP_POSTNU_CDN_URL}imagepavan.webp`}
                  playing con controls
                />
              </div>

            </Col>

          </Row>

          <Row >
            <Col
              xs={12}
              sm={7}
              md={5}
              lg={3}
              className="morgan-mobile  morganimagealign d-block"
            >
              <div className="morgan-new">
              <a
                target="_blank"
                href={links.current.mobileAppURL}
                rel="noopender"
              >
                <img className="w-mobile morgan-mob mb-4" src="https://d2w24n4g34usfg.cloudfront.net/HelloMorgan/images/morgan-logo.webp" width="200px"></img>
                <img src="https://stagingresources.swmc.com/angel-ai/angelai-btn.png" className="w-mobile"/>
              </a>

              </div>
            </Col>
          </Row>

          <Col className="mt-5">
            <p className="morganimagetext">
              Top Real Estate Coach Tom Ferry, and Pavan Agarwal,
              CEO of Sun West, presented together at the event. Pavan Agarwal
              spoke about how {links.current.brandName} returns balance back to your life while
              expanding your business.{" "}
              <a
                className="morganlink"
                target="blank"
                href={links.current.mobileAppURL}
              >
                <strong>{links.current.brandName}</strong>
              </a>{" "}
              hit more than 200 top producers simultaneously and everyone was
              impressed and excited.
              <br />
              <br />
              If you haven’t experienced the {links.current.brandName} magic yet, just go to{" "}
              <a
                className="morganlinka"
                target="blank"
                href={links.current.mobileAppURL}
              >
                {links.current.mobileAppName}
              </a>{" "}
              and test {links.current.brandName} with the toughest questions you would ask a
              lender.
            </p>
          </Col>
        </Col>
      </Row>
    </Container>
  );
}
